import {
  SharePlugin,
  PluginResponse,
  NativeEvent,
} from '@absis/core-plugins/dist/types/types/core-plugins-types';

export const CBShare: SharePlugin = {
  share(): Promise<PluginResponse<NativeEvent>> {
    return Promise.reject(
      new Error('CBShare is not supported for Desktop devices')
    );
  },
  shareFile(): Promise<PluginResponse<NativeEvent>> {
    return Promise.reject(
      new Error('CBShare is not supported for Desktop devices')
    );
  },
};
